import { ViableAccountsType } from '@givebacks/api/core';
import { createModalsFactory } from 'ui';

type TransferAccountModalIds =
  | 'AvailableBalance'
  | 'LinkedAccounts'
  | 'TransferAvailableBalance'
  | 'CreateHyperwalletAccount'
  | 'ConnectBank'
  | 'ConnectPayPal'
  | 'ConnectVenmo'
  | 'RemoveAccount'
  | 'ConnectAccount'
  | 'SelectCause'
  | 'DonateCashback'
  | 'ConfirmDonation';

type TransferAccountModalsMeta = {
  removeAccountType?: ViableAccountsType;
  removeAccountId?: string;
  /** What type of account is called when the hyper wallet account is created */
  createAccountType?: ViableAccountsType;
  causeId?: string;
};

const {
  Provider: TransferAccountsModalGroupProvider,
  useProvider: useTransferAccountsModalGroupProvider,
  ModalTitleWithBackButton: TransferAccountModalTitleWithBackButton,
} = createModalsFactory<TransferAccountModalIds[], TransferAccountModalsMeta>([
  'AvailableBalance',
  'LinkedAccounts',
]);

export {
  TransferAccountModalTitleWithBackButton,
  TransferAccountsModalGroupProvider,
  useTransferAccountsModalGroupProvider,
};
export type { TransferAccountModalIds };
